import React from 'react';
import axios from 'axios';
import moment from 'moment';
import $ from 'jquery';
import trans from '../../translations';
import Modelizer from 'ryvendor/Ry/Core/Modelizer';
import {Popup, PopupHeader, PopupBody} from 'ryvendor/bs/bootstrap';
import swal from 'sweetalert2';

class Item extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            open: false,
            loading: false,
            detail: null,
            error: ''
        };

        this.toggleDetail = this.toggleDetail.bind(this);
        this.deleteCjid = this.deleteCjid.bind(this);
    }

    deleteCjid(event)
    {
        event.preventDefault();
        event.stopPropagation();

        if (this.state.deleting) {
            return false;
        }

        const self = this;
        const item = this.props.data || {};

        swal({
            title: trans('Confirmation'),
            text: trans(
                'Voulez-vous supprimer définitivement ce CJID ?'
            ),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: trans('Oui'),
            cancelButtonText: trans('Non')
        })
        .then(function (result) {
            if (!result.value) {
                return;
            }

            self.setState({
                deleting: true,
                error: ''
            });

            axios.post('/deletecjid', {
                inbound_cjid_id: item.id
            })
            .then(function (response) {
                if (
                    response.data &&
                    response.data.message === 'OK'
                ) {
                    return swal({
                        title: trans('Succès'),
                        text: trans('Le CJID a été supprimé.'),
                        type: 'success',
                        confirmButtonText: trans('OK')
                    });
                }

                throw new Error(
                    response.data && response.data.message
                        ? response.data.message
                        : trans('La suppression du CJID a échoué.')
                );
            })
            .then(function () {
                if (typeof self.props.onDeleted === 'function') {
                    self.props.onDeleted(item.id);
                    return;
                }

                window.location.reload();
            })
            .catch(function (error) {
                let message = trans(
                    'La suppression du CJID a échoué.'
                );

                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                ) {
                    message = error.response.data.message;
                } else if (error.message) {
                    message = error.message;
                }

                self.setState({
                    deleting: false,
                    error: message
                });

                swal({
                    title: trans('Erreur'),
                    text: message,
                    type: 'error',
                    confirmButtonText: trans('OK')
                });
            });
        });

        return false;
    }

    toggleDetail(event)
    {
        event.preventDefault();

        if (this.state.detail) {
            this.setState({
                open: !this.state.open
            });
            return false;
        }

        const self = this;

        self.setState({
            loading: true,
            error: ''
        });

        axios.get('/inboundcjid', {
            params: {
                id: self.props.data.id,
                json: true
            }
        })
        .then(function (response) {
            const detail = response.data && response.data.data
                ? response.data.data
                : response.data;

            self.setState({
                loading: false,
                open: true,
                detail: detail
            });
        })
        .catch(function (error) {
            let message = trans('Impossible de charger le détail.');

            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                message = error.response.data.message;
            }

            self.setState({
                loading: false,
                error: message
            });
        });

        return false;
    }

    getCarrierCode()
    {
        const item = this.props.data || {};

        if (item.airline && item.airline.iata_code) {
            return item.airline.iata_code;
        }

        if (item.attributed_carrier && item.attributed_carrier.iata_code) {
            return item.attributed_carrier.iata_code;
        }

        return item.carrier || 'XX';
    }

    getCarrierName()
    {
        const item = this.props.data || {};

        if (item.airline && item.airline.name) {
            return item.airline.name;
        }

        if (item.attributed_carrier && item.attributed_carrier.name) {
            return item.attributed_carrier.name;
        }

        return this.getCarrierCode();
    }

    renderCarrier()
    {
        const item = this.props.data || {};
        const carrierCode = this.getCarrierCode();
        const carrierName = this.getCarrierName();
        const popupId = 'inbound-cjid-carrier-' + item.id;

        return <td>
            {carrierCode}
            <a href="#" onClick={function (event) {
                event.preventDefault();
                $('#' + popupId).modal('show');
            }}>
                <i className="fa fa-info-circle text-turquoise ml-1"></i>
            </a>

            <Popup id={popupId} className="airport-modal">
                <PopupHeader
                    className="pl-3 pb-2"
                    closeButton={
                        <span
                            aria-hidden="true"
                            className="pb-1 pl-2 pr-2 rounded text-white"
                            style={{background: '#170000'}}
                        >
                            &times;
                        </span>
                    }
                >
                    <h5>
                        <img
                            src="/medias/images/ico-airport.png"
                            className="position-absolute"
                        />
                        <span className="pl-5 text-body">
                            {trans('Carrier')}
                        </span>
                    </h5>
                </PopupHeader>

                <hr
                    className="border m-0 m-auto"
                    style={{width: 'calc(100% - 10px)', height: 3}}
                />

                <PopupBody>
                    <div dangerouslySetInnerHTML={{__html: carrierName}}></div>
                </PopupBody>
            </Popup>
        </td>;
    }

    renderDetail()
    {
        if (!this.state.open || !this.state.detail) {
            return null;
        }

        const receptacles = Array.isArray(this.state.detail.receptacles)
            ? this.state.detail.receptacles
            : [];

        return <tr className="detail">
            <td colSpan="7" className="no-padding">
                <div className="bandeau">
                    <span className="title-bandeau">
                        {trans('Liste des récipients')}
                    </span>
                </div>

                <div className="tableBottom p-3">
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>{trans('Receptacle ID')}</th>
                                    <th>{trans('CARDIT')}</th>
                                    <th>{trans('Weight')}</th>
                                    <th>{trans('Delivered at')}</th>
                                </tr>
                            </thead>

                            <tbody>
                                {receptacles.length > 0
                                    ? receptacles.map(function (item) {
                                        return <tr key={'cjid-receptacle-' + item.id}>
                                            <td>{item.receptacle_id}</td>
                                            <td>{item.cardit_number || '-'}</td>
                                            <td>
                                                {parseFloat(item.weight || 0).toFixed(1)} kg
                                            </td>
                                            <td>
                                                {item.delivered_at
                                                    ? moment.utc(item.delivered_at).format('DD/MM/YYYY HH:mm')
                                                    : '-'}
                                            </td>
                                        </tr>;
                                    })
                                    : <tr>
                                        <td colSpan="4" className="text-center">
                                            {trans('Aucun récipient')}
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </td>
        </tr>;
    }

    render()
    {
        const item = this.props.data;
        const scanReceived =
            item.delivery_scan_received === true ||
            item.delivery_scan_received === 1 ||
            item.delivery_scan_received === '1';

        return <React.Fragment>
            <tr>
                <td className="green">
                    {moment.utc(item.event_at).format('DD/MM/YYYY HH:mm')}
                </td>

                <td className="green">
                    <div className="d-flex align-items-center px-3">
                        <span
                            type="button"
                            className="p-0 mr-2 text-danger"
                            onClick={this.deleteCjid}
                            disabled={this.state.deleting}
                            title={trans('Supprimer le CJID')}
                        >
                            {this.state.deleting
                                ? <i className="fas fa-spinner fa-spin"></i>
                                : <i className="fa fa-trash"></i>}
                        </span>
                            
                        <span className="d-inline-block px-2 list-document-number">
                            {item.cjid}
                        </span>

                        <a
                            href="#"
                            onClick={this.toggleDetail}
                            className="btnAccord"
                        >
                            {this.state.loading
                                ? <i className="fas fa-spinner fa-spin"></i>
                                : <i className={
                                    'fa ' +
                                    (this.state.open
                                        ? 'fa-sort-up'
                                        : 'fa-sort-down')
                                }></i>}
                        </a>
                    </div>

                    {this.state.error
                        ? <small className="text-danger d-block px-3">
                            {this.state.error}
                        </small>
                        : null}
                </td>

                <td>{item.station || '-'}</td>
                {this.renderCarrier()}
                <td>{parseInt(item.pieces || 0, 10)}</td>
                <td>{parseFloat(item.total_weight || 0).toFixed(2)}</td>
                <td className="text-center">
                    {scanReceived
                        ? <span
                            className="btn-turquoise px-3 py-1 text-white w-auto"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                                item.delivered_at
                                    ? moment.utc(item.delivered_at).format('DD/MM/YYYY HH:mm')
                                    : trans('Scan reçu')
                            }
                        >
                            {trans('Final delivery confirmed')}
                        </span>
                        : <span className="btn-orange px-3 py-1 text-white w-auto">
                            {trans('Final delivery not confirmed')}
                        </span>}
                </td>
            </tr>

            {this.renderDetail()}
        </React.Fragment>;
    }
}

export default Modelizer(Item);
